
import { createClient } from '@supabase/supabase-js'

// Utilisation du domaine personnalisé Supabase
export const supabaseUrl = 'https://api.scaloo.ai'
export const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVsZWRseHRyY2FzbnhqamFyZnRpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA3MTA4MTksImV4cCI6MjA1NjI4NjgxOX0.dXnNs6hfwolaWcpmONdZitGuwTVp6YTx4rwQh9k1siE'

// Création du client Supabase avec des options pour le debug
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})
